import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CampaignsPage } from '../screens/admin/CampaignsPage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
  /** Narrow to one partner's companies: its code at sign-up, `none` for companies no partner sent, or `unlinked` for those a partner sent that have no partner link now. */
  partner: z
    .string()
    .regex(/^([A-Za-z2-9]{4}|none|unlinked)$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/admin/campaigns')({
  validateSearch: searchSchema,
  component: CampaignsPage,
});
